import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniLuokitus;
var iniKustannuspaikka;
var iniOrganisaatio;

class KustannuspaikkaLinkitysEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            Luokitus: data[0].luokitus,
            Lahdenumero: data[0].lahdenumero,
            Lahdenimi: data[0].lahdenimi,
            KustannuspaikkaAvain: data[0].kustannuspaikkaAvain,
            OrganisaatioAvain: data[0].organisaatioAvain,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            luokitukset: (Object.keys(props.lookupLists.luokitukset).map((d) => ({ value: d, label: props.lookupLists.luokitukset[d] })) || []),
            kustannuspaikat: (Object.keys(props.lookupLists.kustannuspaikat).map((d) => ({ value: d, label: props.lookupLists.kustannuspaikat[d] })) || []),
            organisaatiot: (Object.keys(props.lookupLists.organisaatiot).map((d) => ({ value: d, label: props.lookupLists.organisaatiot[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniLuokitus = this.state.luokitukset.find(({ value }) => value === (this.state.Luokitus || '').toString());
        iniKustannuspaikka = this.state.kustannuspaikat.find(({ value }) => value === (this.state.KustannuspaikkaAvain || '').toString());
        iniOrganisaatio = this.state.organisaatiot.find(({ value }) => value === (this.state.OrganisaatioAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            Luokitus: this.state.data[0].luokitus,
            Lahdenumero: this.state.data[0].lahdenumero,
            Lahdenimi: this.state.data[0].lahdenimi,
            KustannuspaikkaAvain: this.state.data[0].kustannuspaikkaAvain,
            OrganisaatioAvain: this.state.data[0].organisaatioAvain,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            Luokitus: this.state.Luokitus,
            Lahdenumero: this.state.Lahdenumero,
            Lahdenimi: this.state.Lahdenimi,
            KustannuspaikkaAvain: this.state.KustannuspaikkaAvain,
            OrganisaatioAvain: this.state.OrganisaatioAvain,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });
        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, luokitukset, kustannuspaikat, organisaatiot } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Inventory.KustannuspaikkaLinkitys.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniLuokitus}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Luokitus')}
                                options={luokitukset}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Inventory.KustannuspaikkaLinkitys.Columns[1]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Inventory.KustannuspaikkaLinkitys.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Lahdenumero}
                            onChange={this.handleChange('Lahdenumero')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Inventory.KustannuspaikkaLinkitys.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Lahdenimi}
                            onChange={this.handleChange('Lahdenimi')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniKustannuspaikka}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'KustannuspaikkaAvain')}
                                options={kustannuspaikat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Inventory.KustannuspaikkaLinkitys.Columns[4]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniOrganisaatio}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'OrganisaatioAvain')}
                                options={organisaatiot}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Inventory.KustannuspaikkaLinkitys.Columns[5]} />}
                            />
                        </Box>
                    </DialogContent>
                    {/* TODO:THEME */}
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "KustannuspaikkaLinkitysEdit" })(KustannuspaikkaLinkitysEdit);
